import LoginForm from "../components/login-form.tsx";

function Login() {
  return <LoginForm />;
}

export default Login;
